var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqArrowMintGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4164 7.14693C14.3582 7.20561 14.289 7.25217 14.2127 7.28395C14.1364 7.31573 14.0546 7.3321 13.972 7.3321C13.8893 7.3321 13.8075 7.31573 13.7312 7.28395C13.6549 7.25217 13.5857 7.20561 13.5275 7.14693L10.648 4.26744L10.648 19.0029C10.648 19.1689 10.5821 19.3282 10.4647 19.4456C10.3473 19.563 10.1881 19.6289 10.022 19.6289C9.85603 19.6289 9.69681 19.563 9.57941 19.4456C9.46202 19.3282 9.39607 19.1689 9.39607 19.0029L9.39607 4.27996L6.53536 7.14693C6.41807 7.26352 6.25942 7.32896 6.09404 7.32896C5.92867 7.32896 5.77001 7.26352 5.65273 7.14693C5.53614 7.02965 5.4707 6.87099 5.4707 6.70562C5.4707 6.54025 5.53614 6.38159 5.65273 6.26431L9.63394 2.28309C9.68535 2.22951 9.74706 2.18687 9.81537 2.15775C9.88368 2.12862 9.95717 2.11361 10.0314 2.11361C10.1057 2.11361 10.1792 2.12862 10.2475 2.15775C10.3158 2.18687 10.3775 2.22951 10.4289 2.28309L14.4164 6.25805C14.4751 6.31624 14.5216 6.38547 14.5534 6.46175C14.5852 6.53804 14.6016 6.61985 14.6016 6.70249C14.6016 6.78513 14.5852 6.86694 14.5534 6.94322C14.5216 7.01951 14.4751 7.08874 14.4164 7.14693Z",
    fill: "#33D6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrowMintGreen);
export default __webpack_public_path__ + "static/media/faqArrowMintGreen.eeb9055fee3df845752c259c96c28f65.svg";
export { ForwardRef as ReactComponent };